import React from 'react';
import { useLocation } from 'react-router-dom';

import DashboardCalendar from './DashboardCalendar';
import UpcomingTradeShowsList from '../market-intel/TradeShows/UpcomingTradeShowsList';
import { PlatformUpdateAlert } from '../../shared/PlatformUpdateStatus';
import { DashboardShell, TileSection, ActionList, listCount, useRefreshKey } from '../../shared/LiveDashboard';

// Home Dashboard: what needs someone now, then the key figures to drill
// into, then the calendar. Live data only (shared/LiveDashboard.js); each
// line and tile shows only to Roles that can open the screen it counts.

// Most urgent first: customers waiting on us, then our own overdue work.
const NEEDS_ACTION = [
  { key: 'portal-orders', label: 'Portal orders awaiting acceptance', urgent: true, screen: 'sales-orders', count: listCount('/api/sales-orders', { awaiting_portal: 'true', limit: 1 }), to: '/sales-orders', state: { initialFilters: { awaiting_portal: true } } },
  { key: 'website-enquiries', label: 'Website enquiries waiting', urgent: true, screen: 'crm-website-enquiries', count: listCount('/api/website-enquiries/waiting-count'), to: '/crm-website-enquiries' },
  { key: 'overdue-todos', label: 'Your overdue to-dos', urgent: true, screen: 'crm-activities', count: listCount('/api/activities/log', { scope: 'mine', task_status: 'overdue', limit: 1 }), to: '/crm-activities', state: { initialFilters: { scope: 'mine', task_status: 'overdue' } } },
  { key: 'backorders', label: 'Sales Orders on backorder', screen: 'sales-orders', count: listCount('/api/sales-orders', { backorder: 'true', limit: 1 }), to: '/sales-orders', state: { initialFilters: { backorder: true } } },
];

const KEY_FIGURES = [
  { key: 'open-orders', label: 'Open Orders', screen: 'sales-orders', icon: 'Open Orders', count: listCount('/api/sales-orders', { status: 'draft', limit: 1 }), to: '/sales-orders', state: { initialFilters: { status: 'draft' } } },
  { key: 'quotes-sent', label: 'Quotes Awaiting Customer', screen: 'sales-quotes', icon: 'Outstanding Invoices', count: listCount('/api/quotes', { status: 'sent', limit: 1 }), to: '/sales-quotes', state: { initialFilters: { status: 'sent' } } },
  { key: 'ready-to-ship', label: 'Ready to Ship', screen: 'warehouse-ship', icon: 'Backorders', count: listCount('/api/sales-orders', { open_for_shipping: 'true', limit: 1 }), to: '/warehouse-ship' },
  { key: 'open-todos', label: 'Your Open To-dos', screen: 'crm-activities', icon: 'Open Orders', count: listCount('/api/activities/log', { scope: 'mine', task_status: 'open', limit: 1 }), to: '/crm-activities', state: { initialFilters: { scope: 'mine', activity_type: 'task', task_status: 'open' } } },
];

function Dashboard() {
  // Another screen can open this one on a calendar view, e.g. the CRM
  // Dashboard's Upcoming card.
  const location = useLocation();
  const [refreshKey, refresh] = useRefreshKey();

  return (
    <DashboardShell
      title="Home Dashboard"
      description="What needs action now, the key figures, and your calendar."
      onRefresh={refresh}
    >
      <PlatformUpdateAlert />

      <ActionList title="Needs Action" items={NEEDS_ACTION} refreshKey={refreshKey} emptyText="Nothing waiting on you." />

      <TileSection title="Key Figures" tiles={KEY_FIGURES} refreshKey={refreshKey} />

      <div className="metrics-section">
        <h2>Calendar</h2>
        <DashboardCalendar initialView={location.state?.calendarView} />
      </div>

      {/* Heading outside the card, same as Calendar above. */}
      <div className="metrics-section">
        <h2>Upcoming Trade Shows</h2>
        <div style={{ background: '#fff', border: '1px solid #b3bbc7', borderRadius: 10, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <UpcomingTradeShowsList limit={5} />
        </div>
      </div>
    </DashboardShell>
  );
}

export default Dashboard;
